import classnames from 'classnames'
import { Field, FieldType } from 'embed/constants'
import ThemeConsumer from 'embed/components/ThemeConsumer'
import { Tooltip } from 'embed/components/Tooltip'
import { css } from 'emotion'
import * as React from 'react'

const styles = require('embed/styles/application')
const applicationFieldStyles = require('../styles')
const InfoSmall = require('../info-grey.svg')

export const FieldTooltip = ({
  className,
  field,
  shouldShowIsInvalid,
  useFloatingLabelInputs,
}: {
  className?: string
  field: Field
  shouldShowIsInvalid: boolean
  useFloatingLabelInputs?: boolean
}) => (
  <ThemeConsumer>
    {({ colorPrimary, errorStyles }) => (
      <React.Fragment>
        <Tooltip
          overlay={field.options.tooltip}
          overlayStyle={{ maxWidth: '300px' }}
          placement="top"
          trigger={['hover', 'click']}
        >
          <span
            className={classnames(
              styles.infoIcon,
              applicationFieldStyles.infoIcon,
              css(
                useFloatingLabelInputs &&
                  (shouldShowIsInvalid
                    ? `transform: rotate(180deg); path { fill: ${errorStyles?.color}; }`
                    : `path { fill: ${colorPrimary}; }`),
              ),
              {
                [applicationFieldStyles.floatingLabelSelectInfoIcon]:
                  (useFloatingLabelInputs && field.type === FieldType.Select) || field.type === FieldType.DynamicSelect,
              },
              className,
            )}
          >
            <InfoSmall />
          </span>
        </Tooltip>
      </React.Fragment>
    )}
  </ThemeConsumer>
)
